import React from 'react'
import { useHistory } from 'react-router';
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

function KOR() {
    const history = useHistory();
    let settings = {
        infinite: true,
        fade: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    };

    return (
        <div>
            <div className="battlepass_midimg width">
                <img src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-characters-bg-2880x2241-f4710adffd1b.jpg" alt="" />
            </div>

            <div className="battle_pass_stars ">
                <img src="https://cdn2.unrealengine.com/battlepass-battlestar-277x252-579065405.png" alt="" />
            </div>

            <div className="battlepass_info">
                <p>ENTER THE SIDEWAYS
                </p>
            </div>
            <div className="battlepass__own">
                <p>MY SELF - KOR</p>
            </div>



            {/* logo png images1 */}
            <div className="slider_subimg_logo1 ">
                <img src="https://cdn2.unrealengine.com/18-bling-bp-kor-stoolkit-199x213-23664779e003.png" alt="" />
            </div>

            {/* logo png images2 */}
            <div className="slider_subimg_logo2  ">
                <img src="https://cdn2.unrealengine.com/18-screen-bp-loading-onthejob-3d-307x245-ee3643c6c4aa.png" alt="" />
            </div>

            {/* logo png images3 */}
            <div className="slider_subimg_logo3">
                <img src="
               https://cdn2.unrealengine.com/18-axe-bp-korflails-528x397-d1f259697cf7.png" alt="" />
            </div>


            {/* logo png images4 */}
            <div className="slider_subimg_logo4 ">
                <img src="https://cdn2.unrealengine.com/18-spray-bp-splinterfaction-215x223-5ccfc8409f23.png" alt="" />
            </div>

            <Carousel2 {...settings}>

                <Wrap>
                    <a>
                        <img
                            src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-kor-variant1-2080x2136-fa4712c428d2.png" alt="" />
                    </a>
                </Wrap>
                <Wrap>
                    <a>
                        <img
                            src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-kor-variant2-2080x2136-67b5db94e8a2.png" alt="" />
                    </a>
                </Wrap>
                <Wrap>
                    <a>
                        <img
                            src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-kor-variant3-2080x2136-cf22e583e9fa.png" alt="" />
                    </a>
                </Wrap>

                <Wrap>
                    <a>
                        <img
                            src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-kor-variant4-2080x2136-bff310ffe24a.png" alt="" />
                    </a>
                </Wrap>

                <Wrap>
                    <a>
                        <img
                            src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-kor-variant6-2080x2136-25e805440035.png" alt="" />
                    </a>
                </Wrap>


            </Carousel2>



        </div>
    )
}

export default KOR





const Carousel2 = styled(Slider)`
::-webkit-scrollbar {
    width: 0;
  }
  
  margin-top: -1730px;
  margin-bottom: 220px;
 overflow-X:hidden;

  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;

    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }

  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 158, 171);
    }
  }

  li.slick-active button:before {
    color: white;
  }

  .slick-list {
    overflow: initial;
  }

  .slick-prev {
    left: -75px;
  }

  .slick-next {
    right: -75px;
  }
`;

const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  ::-webkit-scrollbar {
    width: 0;
  }
  

  a {
    border-radius: 4px;

    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;

    img {
      width: 60%;
      margin-left:auto;
      margin-right:auto;
      

    }
`;



